"use client"

import { useLayoutEffect, useState } from "react"

export function useMounted() {
  const [mounted, setMounted] = useState(false)

  useLayoutEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true)

    return () => {
      setMounted(false)
    }
  }, [])

  return mounted
}
